import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from 'dayjs';
import XLSX from "xlsx";
import AlertResponse from "../../shared/general/AlertResponse";
import DrawerCustom from "../../shared/general/Drawer";
import DialogSelectDate from "./component/dialogWithSelectDate";
import { getEmailReportById } from "../../../../actions/email";
import { getTaxemployee } from "../../../../actions/report";

const Tax = (props) => {
    const dispatch = useDispatch();
    const { result: taxDeduction } = useSelector((state) => state.taxDeduction);
    const { result: userProfile } = useSelector((state) => state.userProfile);
    const { result: email } = useSelector((state) => state.email)
    const { open, handleClose } = props;
    const [openAlert, setOpenAlert] = useState(false);
    const [alertType, setAlertType] = useState(false);
    const [data, setData] = useState({
        inputSearch: new Date(),
        value: "year",
        autoEmail: null,
        selectedCompany: null,
        ReportName: "tax",
        idEmployees: userProfile.idEmployees
    })

    useEffect(()=>{
        if(email)
        setData({ ...data, autoEmail: email.day });
    },[email])

    const handleOpenAlert = () => {
        setOpenAlert(true);
    };

    const handleCloseAlert = () => {
        setOpenAlert(false);
    };

    const handleChangeAlertType = (newValue) => {
        setAlertType(newValue);
    };

    useEffect(()=>{
        dispatch(getEmailReportById(data.idEmployees, "tax"))
    },[])

    useEffect(() => {
        if (data.value === "year") {
            dispatch(getTaxemployee(data.selectedCompany, dayjs(data.inputSearch).endOf('month')))
        } else dispatch(getTaxemployee(data.selectedCompany, dayjs(data.inputSearch).startOf('month')))
    }, [data.inputSearch, data.selectedCompany, data.value])

    const handleSubmit = () => {
        if (taxDeduction.length > 0) {
            const elementList = [];
            for (let index = 0; index < taxDeduction.length; index++) {
                const element = {
                    "#": index + 1,
                    "รหัสพนักงาน": taxDeduction[index].idEmployees,
                    "ชื่อ": taxDeduction[index].firstname_TH,
                    "สกุล": taxDeduction[index].lastname_TH,
                    "Division": taxDeduction[index].Division,
                    "Department": taxDeduction[index].department,
                    "Section": taxDeduction[index].Section,
                    "Unit/Process": taxDeduction[index].Positions,
                    "รายการที่คีย์ลดหย่อน": taxDeduction[index].list,
                    "จำนวนที่คีย์ลดหย่อน": taxDeduction[index].value,
                    "วันที่คีย์ลดหย่อนภาษีล่าสุด": dayjs(taxDeduction[index].date).format("YYYY-MM-DD"),
                };
                elementList.push(element);
            }
            const workSheet = XLSX.utils.json_to_sheet(elementList);
            const workBook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(workBook, workSheet, "รายงานลดหย่อนภาษี");
            XLSX.writeFile(workBook, "รายงานลดหย่อนภาษี.xlsx");

            handleChangeAlertType("success");
            handleOpenAlert(true);
            handleClose();
        } else {
            handleChangeAlertType("ไม่พบข้อมูล");
            handleOpenAlert(true);
        }
    }

    return (
        <DrawerCustom
            title="รายงานลดหย่อนภาษี"
            anchor="right"
            open={open}
            onClose={handleClose}
        >
            <DialogSelectDate
                handleSubmit={handleSubmit}
                handleClose={handleClose}
                setData={setData}
                data={data}
                handleChangeAlertType={handleChangeAlertType}
                handleOpenAlert={handleOpenAlert}
                select={true}
                excel={taxDeduction}
            />
            <AlertResponse
                open={openAlert}
                handleClose={handleCloseAlert}
                alertType={alertType}
            />
        </DrawerCustom>
    );
}

export default Tax;
